export default __webpack_public_path__ + "static/media/encantos_wordmark_purple.68d1fd9f.png";